const ON_FOCUS = '@@redux-form/FOCUS';
const ON_BLUR = '@@redux-form/BLUR';
const ON_ARRAY_REMOVE = '@@redux-form/ARRAY_REMOVE';

export default {
  ON_FOCUS,
  ON_BLUR,
  ON_ARRAY_REMOVE
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/formConstants.js